import dayjs from 'dayjs';
import { HeaderProps as RbcHeaderProps } from 'react-big-calendar';
import { StyledScheduleColumnHeader } from './ScheduleColumnHeader.styles';

export const ScheduleColumnHeader = ({ date }: RbcHeaderProps): JSX.Element => {
  const isToday = dayjs(date).isSame(dayjs(), 'day');

  return (
    <StyledScheduleColumnHeader $isToday={isToday}>
      <span className="schedule-column-header__day-name">{dayjs(date).format('ddd')}</span>
      <span className="schedule-column-header__day-number">{dayjs(date).format('DD')}</span>
    </StyledScheduleColumnHeader>
  );
};
